export const adresa = () => ({
  id: "datumPosledniAktivity",
  label: "b2b.zakaznici-grid-columns.adresa.label",
  path: "adresa"
});

export const ico = () => ({
  id: "doplnkoveSluzby",
  label: "b2b.zakaznici-grid-columns.ico.label",
  path: "ico"
});

export const nazev = () => ({
  id: "datumPosledniAktivity",
  label: "b2b.zakaznici-grid-columns.nazev.label",
  path: "nazev"
});
